import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PromisePool } from 'es6-promise-pool';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import {
  Container,
  Input,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIgetTaxonomy,
  APIcreateTaxonomy,
  APIupdateTaxonomy,
  APIgetTerms,
  APIdeleteTaxonomy,
  APIdeleteTerm,
  APIblockTerm,
} from '../../api/Metadata';

import { showModal } from '../../actions';
import { showConfirmationModal } from '../../actions/App';
import { fetchMetadataGroups, fetchTaxonomies } from '../../actions/Metadata';

import AdminTaxonomyEditHeader from '../../components/Admin/TaxonomyEdit/Header';
import AdminTaxonomyEditTabs from '../../components/Admin/TaxonomyEdit/Tabs';
import AdminTaxonomyEditTabContent from '../../components/Admin/TaxonomyEdit/TabContent';
import AdminTermsHeader from '../../components/Admin/Terms/Header';
import AdminTermsList from '../../components/Admin/Terms/List';
import AdminFooter from '../../components/Admin/Footer';
import AdminBulkActionsSelector from '../../components/Admin/BulkActionsSelector';
import GoBackToListButton from '../../components/GoBackToListButton';

import {
  getVisibleItemsText,
  getTabUrlParam,
  updateTabUrlParam,
  pluralize,
} from '../../helpers';
import { userHasFeature } from '../../helpers/Features';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { getUserSetting } from '../../helpers/Settings';
import { handleComponentParams, handleURLParams } from '../../helpers/URLParams';

import Loading from '../../components/Loading';
import ErrorBoundary from '../../components/ErrorBoundary';
import NothingFound from '../../components/NothingFound';
import UpgradeBoard from '../../components/UpgradeBoard';

class AdminTaxonomyEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      taxonomy: null,
      selectedTerms: [],
      terms: [],
      termsTotal: 0,
      search: '',
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'name',
      order: 'asc',
      blockedFilter: 'all',
      errors: [],
      activeTab: getTabUrlParam() || 'details',
      is404: false,
      loading: true,
      termsLoading: true,
      saving: false,
      timestamp: new Date().toISOString(),
    };

    this.searchRef = React.createRef();

    this.handleSave = this.handleSave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSwitchTab = this.handleSwitchTab.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeRole = this.handleChangeRole.bind(this);
    this.handleChangeMetadataGroups = this.handleChangeMetadataGroups.bind(this);
    this.updateTermOnList = this.updateTermOnList.bind(this);
    this.refreshTermList = this.refreshTermList.bind(this);
    this.deleteTermFromList = this.deleteTermFromList.bind(this);
    this.handleAddTerm = this.handleAddTerm.bind(this);
    this.handleImportTerms = this.handleImportTerms.bind(this);
    this.handleDeleteTerms = this.handleDeleteTerms.bind(this);
    this.handleSelectAction = this.handleSelectAction.bind(this);
    this.handleSelectTerm = this.handleSelectTerm.bind(this);
    this.handleBlockedFilter = this.handleBlockedFilter.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['page', 'orderBy', 'order', 'search'],
      null,
      this.setState.bind(this),
      () => {
        this.loadTaxonomy();
        this.loadTerms();
      },
      { orderBy: 'name', order: 'asc' },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history, location.state);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history, location.state);
    }
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    const { match: prevMatch } = prevProps;
    const { taxonomyId } = match.params;
    const { taxonomyId: prevTaxonomyId } = prevMatch.params;

    if (taxonomyId !== prevTaxonomyId) {
      this.setState(({
        taxonomy: null,
        terms: [],
        taxonomyId: null,
        selectedTerms: [],
      }));
      this.loadTaxonomy(true, false);
    }

    handleComponentParams(
      false,
      ['page', 'orderBy', 'order', 'search'],
      prevProps,
      this.setState.bind(this),
      (updatedParams) => {
        if (_.has(updatedParams, 'page')) {
          this.loadTaxonomy(true);
        } else {
          this.loadTaxonomy();
          this.loadTerms();
        }
      },
      { orderBy: 'name', order: 'asc' },
    );
  }

  getTermsDeletePromisePool(terms) {
    let counterTerms = 0;
    const promiseProducerTerms = () => {
      if (counterTerms < terms.length) {
        const term = terms[counterTerms];
        counterTerms += 1;
        return APIdeleteTerm(term).then(() => {
          this.deleteTermFromList({ id: term });
        }).catch((error) => {
          if (error.status !== 404) {
            return new Promise((resolve, reject) => { reject(); });
          }
          return new Promise((resolve) => { resolve(true); });
        });
      }
      return null;
    };

    return new PromisePool(promiseProducerTerms, 2);
  }

  loadTaxonomy(callbackTerms = false, scrollMode = true) {
    const { match } = this.props;
    const { taxonomyId } = match.params;
    if (!taxonomyId) {
      this.setState({
        taxonomy: {
          id: null,
          name: '',
          plural: '',
          mapping: false,
          show_on_shares: false,
          required: false,
          roles: [],
          metadata_groups: [],
        },
        loading: false,
      });

      return;
    }

    this.setState({
      taxonomyId,
      loading: true,
    });

    APIgetTaxonomy(taxonomyId).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          taxonomy: data,
        }, () => {
          if (callbackTerms) {
            this.loadTerms(false, scrollMode);
          }
        });
      } else {
        this.setState({
          loading: false,
          is404: true,
        });
      }
    }).catch(() => {
      this.setState({
        loading: false,
        is404: true,
      });
    });
  }

  loadTerms(silent = false, scrollMode = false) {
    const { match } = this.props;
    const { taxonomyId } = match.params;
    const {
      search,
      page,
      perPage,
      orderBy,
      order,
      blockedFilter,
    } = this.state;

    if (!taxonomyId) {
      return false;
    }

    if (!silent) {
      this.setState({ termsLoading: true });
    }

    return APIgetTerms(taxonomyId, {
      search,
      page,
      per_page: perPage,
      orderby: orderBy,
      order,
      ...(blockedFilter !== 'all' && { blocked: blockedFilter === 'blocked' }),
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          termsLoading: false,
          terms: data.data,
          termsTotal: data.meta.total,
        }, () => {
          if (scrollMode) {
            const offset = document.getElementById('terms-list-header').offsetTop;
            document.querySelector('.main-content').scrollTo({ top: offset, left: 0, behavior: 'smooth' });
          }
        });
      }
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history, location } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history, location.state);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history, location } = this.props;
    handleURLParams({ page }, history, location.state);

    this.setState({ page });
  }

  handleChangeSearch(e) {
    const { value } = e.target;
    this.setState({ search: value });
  }

  handleClearSearch(e) {
    e.preventDefault();
    const { history, location } = this.props;
    handleURLParams({ search: '', page: 1 }, history, location.state);

    this.searchRef.value = '';
    this.setState({
      search: '',
      page: 1,
    });
  }

  handleKeyDown(e) {
    const { search } = this.state;
    const { history, location } = this.props;

    if (e.key === 'Enter') {
      e.preventDefault();
      handleURLParams({ search, page: 1 }, history, location.state);
      this.setState({ page: 1 });
    }
  }

  resetState() {
    this.setState({
      saving: false,
      errors: [],
    });
  }

  handleError() {
    const {
      intl,
    } = this.props;
    this.resetState();
    addFlashMessage({
      type: 'danger',
      text: intl.formatMessage({ defaultMessage: 'Something went wrong! Please try again.' }),
    });
  }

  saveTaxonomy() {
    const {
      taxonomyId,
      taxonomy,
    } = this.state;
    const {
      intl,
      history,
      fetchAllTaxonomies,
      loadMetadataGroups,
    } = this.props;

    if (!taxonomy.name) {
      this.setState({ errors: ['name'] });
      return;
    }
    if (!taxonomy.plural) {
      this.setState({ errors: ['plural'] });
      return;
    }

    this.setState({
      saving: true,
      errors: [],
    });

    if (taxonomyId) {
      APIupdateTaxonomy(taxonomy).then(() => {
        loadMetadataGroups();
        fetchAllTaxonomies();
        this.resetState();
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'The changes have been saved' }),
        });
      }).catch(() => {
        this.handleError();
      });
    } else {
      APIcreateTaxonomy(taxonomy).then((response) => {
        loadMetadataGroups();
        fetchAllTaxonomies();
        this.resetState();
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'The new Tag Category has been created' }),
        });
        const { data } = response;
        if (data && data.id) {
          history.push(`/admin/settings/categories/${data.id}/edit`);
        }
      }).catch(() => {
        this.handleError();
      });
    }
  }

  handleSave() {
    this.saveTaxonomy();
  }

  handleSwitchTab(tab) {
    this.setState({ activeTab: tab });
    updateTabUrlParam(tab);
  }

  handleChange(e) {
    const {
      value,
      name,
      checked,
    } = e.target;
    const { taxonomy } = this.state;
    if (name === 'name' || name === 'plural') {
      taxonomy[name] = value;
    }
    if (name === 'mapping' || name === 'show_on_shares') {
      taxonomy[name] = checked;
    }
    if (name === 'taxonomy_required') {
      taxonomy.required = checked;
    }
    this.setState({ taxonomy });
  }

  handleChangeRole(roleId, permission, value) {
    this.setState(prevState => {
      const { taxonomy } = prevState;
      const existingRole = taxonomy.roles.find(role => role.id === roleId);

      let role;

      if (existingRole) {
        role = {
          ...existingRole,
          [permission]: value,
        };
      } else {
        role = {
          id: roleId,
          can_view: true,
          can_add: true,
          read_only: false,
          [permission]: value,
        };
      }

      // Permission dependencies
      if (permission === 'can_view' && value === false) {
        role.can_add = false;
        role.read_only = false;
      }

      if (permission === 'can_add' && value === true) {
        role.can_view = true;
        role.read_only = false;
      }

      if (permission === 'read_only' && value === true) {
        role.can_view = true;
        role.can_add = false;
      }

      if (existingRole) {
        taxonomy.roles = taxonomy.roles.map(r => (r.id === roleId ? role : r));
      } else {
        taxonomy.roles.push(role);
      }

      return { taxonomy };
    });
  }

  handleChangeMetadataGroups(metadataGroups) {
    this.setState(prevState => {
      const { taxonomy } = prevState;
      taxonomy.metadata_groups = metadataGroups;

      return { taxonomy };
    });
  }

  updateTermOnList(term) {
    const { terms } = this.state;

    const idx = terms.findIndex(t => (t.id === term.id));
    if (idx >= 0) {
      terms[idx] = term;
      this.setState({
        terms,
        timestamp: new Date().toISOString(),
      });
    }
  }

  refreshTermList() {
    this.setState({ selectedTerms: [] });
    this.loadTerms(true);
  }

  deleteTermFromList(term) {
    this.setState(prevState => ({
      terms: prevState.terms.filter(t => (t.id !== term.id)),
    }));
    this.loadTerms(true);
  }

  handleAddTerm() {
    const { openTermEditModal } = this.props;
    const { taxonomyId, taxonomy } = this.state;

    openTermEditModal({
      className: 'modal-new-term',
      taxonomyId,
      aiTagging: taxonomy.ai_tagging,
      afterCreateTerm: () => {
        this.loadTerms(true);
      },
    });
  }

  handleImportTerms() {
    const { openTermsImportModal, history, location } = this.props;
    const { taxonomy } = this.state;

    openTermsImportModal({
      className: 'modal-import-terms',
      taxonomy,
      afterImportTerms: () => {
        handleURLParams({
          search: '', page: 1, orderBy: 'name', order: 'asc',
        }, history, location.state);
        this.setState({
          search: '',
          page: 1,
          orderBy: 'name',
          order: 'asc',
        }, () => {
          this.loadTerms();
        });
      },
    });
  }

  handleDelete(e) {
    e.preventDefault();
    const {
      history,
      handleDeleteTaxonomy,
    } = this.props;
    const { taxonomy } = this.state;

    handleDeleteTaxonomy(taxonomy, () => {
      history.push('/admin/settings/categories');
    });
  }

  handleSelectTerm(e) {
    const {
      value,
      checked,
    } = e.target;
    const {
      selectedTerms,
      terms,
    } = this.state;

    if (value === 'all') {
      if (checked) {
        this.setState({ selectedTerms: terms.map(t => (t.id)) });
      } else {
        this.setState({ selectedTerms: [] });
      }
      return;
    }

    if (selectedTerms.includes(parseInt(value))) {
      this.setState(prevState => ({
        selectedTerms: prevState.selectedTerms.filter(st => (st !== parseInt(value))),
      }));
    } else {
      this.setState(prevState => ({
        selectedTerms: [...prevState.selectedTerms, parseInt(value)],
      }));
    }
  }

  handleDeleteTerms(terms, callback = () => { }) {
    const {
      intl,
      openConfirmationModal,
    } = this.props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Delete {tagsCount, plural, one {tag} other {tags}}?' }, { tagsCount: terms.length }),
      text: intl.formatMessage({ defaultMessage: 'You are about to delete {tagsCount, plural, one {tag} other {tags}}. Doing this will not delete the associated files, but the {tagsCount, plural, one {tag} other {tags}} will be permanently removed.' }, { tagsCount: terms.length }),
      onConfirm: () => (
        this.getTermsDeletePromisePool(terms).start().then(() => {
          addFlashMessage({
            type: 'success',
            text: intl.formatMessage({ defaultMessage: 'Tags have been deleted' }),
          });
          this.setState({ selectedTerms: [] });
          this.loadTerms(true);
          callback();
        })
      ),
    };
    openConfirmationModal(modalParams);
  }

  handleMoveTerms(selectedTermsIds) {
    const { openTermMoveModal } = this.props;
    const { taxonomyId } = this.state;

    openTermMoveModal({
      taxonomyId,
      selectedTermsIds,
      className: 'modal-move-term',
      afterMoveTerm: () => {
        this.setState({ selectedTerms: [] });
        this.loadTerms(true);
      },
    });
  }

  async handleBlockTerms(selectedTermsIds, type) {
    const { intl } = this.props;
    const { taxonomyId } = this.state;
    try {
      const response = await APIblockTerm(
        { taxonomyId, terms: selectedTermsIds, blocked: type },
      );
      if (response.status !== 200) {
        throw new Error(intl.formatMessage({ defaultMessage: 'An error occured' }));
      }
      this.loadTerms(true);
      addFlashMessage({
        type: 'success',
        text: type ?
          intl.formatMessage({ defaultMessage: 'Tags have been blocked' }) :
          intl.formatMessage({ defaultMessage: 'Tags have been unblocked' }),
      });
    } catch (e) {
      addFlashMessage({
        type: 'danger',
        text: type ?
          intl.formatMessage({ defaultMessage: 'Error occured while blocking tags' }) :
          intl.formatMessage({ defaultMessage: 'Error occured while unblocking tags' }),
      });
    }
  }

  handleSelectAction(action, callback) {
    const { selectedTerms } = this.state;

    if (action === 'delete-terms') {
      this.handleDeleteTerms(selectedTerms, callback);
    }

    if (action === 'move-terms') {
      this.handleMoveTerms(selectedTerms);
    }

    if (action === 'block') {
      this.handleBlockTerms(selectedTerms, true);
    }

    if (action === 'unblock') {
      this.handleBlockTerms(selectedTerms, false);
    }
  }

  handleBlockedFilter(e) {
    this.setState({
      blockedFilter: e.target.value,
    }, () => {
      this.loadTerms();
    });
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      taxonomy,
      taxonomyId,
      selectedTerms,
      termsTotal,
      is404,
      loading,
      termsLoading,
      search,
      page,
      perPage,
      blockedFilter,
    } = this.state;

    if (is404) {
      return (
        <NothingFound />
      );
    }

    if (taxonomy && !userHasFeature('custom-categories') && (!taxonomy.standard && !taxonomy.ai_tagging)) {
      return (
        <UpgradeBoard feature="custom-categories" />
      );
    }

    return (
      <div className="settings-inner-content">
        <div className="main-content taxonomy-edit-content">
          <Container fluid>
            {loading ? (
              <Loading />
            ) : (
              <ErrorBoundary>
                <GoBackToListButton
                  scope="taxonomies"
                />
                <AdminTaxonomyEditHeader
                  taxonomyId={taxonomyId}
                />
                <AdminTaxonomyEditTabs
                  {...this.state}
                  handleSwitchTab={this.handleSwitchTab}
                />
                <ErrorBoundary>
                  <AdminTaxonomyEditTabContent
                    {...this.state}
                    handleChange={this.handleChange}
                    handleChangeRole={this.handleChangeRole}
                    handleChangeMetadataGroups={this.handleChangeMetadataGroups}
                    handleSave={this.handleSave}
                    handleDelete={this.handleDelete}
                  />
                </ErrorBoundary>
              </ErrorBoundary>
            )}
            {(!loading && taxonomyId) && (
              <>
                {termsLoading ? (
                  <Loading />
                ) : (
                  <>
                    <AdminTermsHeader
                      termsTotal={termsTotal}
                      termsVisible={getVisibleItemsText(page, perPage, termsTotal)}
                      handleAddTerm={this.handleAddTerm}
                      handleImportTerms={this.handleImportTerms}
                      loading={termsLoading}
                      taxonomy={taxonomy}
                    />
                    <div className="actions-wrapper">
                      <AdminBulkActionsSelector
                        actions={[
                          {
                            id: 'delete-terms',
                            name: pluralize('Delete tag', selectedTerms.length),
                          },
                          {
                            id: 'move-terms',
                            name: pluralize('Move tag', selectedTerms.length),
                          },
                          {
                            id: 'block',
                            name: 'Block',
                          },
                          {
                            id: 'unblock',
                            name: 'Unblock',
                          },
                        ]}
                        disabled={selectedTerms.length === 0 || termsTotal === 0}
                        handleSelectAction={this.handleSelectAction}
                      />
                      <div className="actions-filters mb-2">
                        <Input
                          type="select"
                          className="custom-select"
                          name="blocked-filter"
                          bsSize="sm"
                          value={blockedFilter}
                          onChange={this.handleBlockedFilter}
                        >
                          <option value="all">
                            {intl.formatMessage({ defaultMessage: 'All terms' })}
                          </option>
                          <option value="blocked">
                            {intl.formatMessage({ defaultMessage: 'Blocked only' })}
                          </option>
                          <option value="not-blocked">
                            {intl.formatMessage({ defaultMessage: 'Not blocked' })}
                          </option>
                        </Input>
                        <div className="position-relative inline-search">
                          <Input
                            id="tag-search"
                            name="tag-search"
                            bsSize="sm"
                            innerRef={(ref) => { this.searchRef = ref; }}
                            placeholder={intl.formatMessage({ defaultMessage: 'Type tag name and press Enter to search' })}
                            disabled={termsLoading}
                            onChange={this.handleChangeSearch}
                            onKeyDown={this.handleKeyDown}
                            value={search || ''}
                          />
                          {search && (
                            <a
                              href="#clear"
                              className="search-clear"
                              onClick={this.handleClearSearch}
                            >
                              <i className="fas fa-times" />
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                    <ErrorBoundary>
                      <AdminTermsList
                        {...this.state}
                        handleChangeOrder={this.handleChangeOrder}
                        updateTermOnList={this.updateTermOnList}
                        refreshTermList={this.refreshTermList}
                        deleteTermFromList={this.deleteTermFromList}
                        handleSelectTerm={this.handleSelectTerm}
                      />
                    </ErrorBoundary>
                    <ErrorBoundary>
                      <AdminFooter
                        {...this.state}
                        itemsTotal={termsTotal}
                        handleChangePage={this.handleChangePage}
                      />
                    </ErrorBoundary>
                  </>
                )}
              </>
            )}
          </Container>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  handleDeleteTaxonomy: (taxonomy, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: `Are you sure you want to delete this Tag Category?
          Doing this will delete ALL the tags associated with this Tag
          Category and they cannot be recovered. Files will NOT be deleted.`,
      }),
      onConfirm: () => (
        APIdeleteTaxonomy(taxonomy.id).then(() => {
          dispatch(fetchTaxonomies());
          callback(taxonomy);
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
  openTermMoveModal: (params) => {
    dispatch(showModal('TermMoveModal', params));
  },
  openTermEditModal: (params) => {
    dispatch(showModal('TermEditModal', params));
  },
  openTermsImportModal: (params) => {
    dispatch(showModal('TermsImportModal', params));
  },
  openTaxonomyDeleteModal: (params) => {
    dispatch(showModal('TaxonomyDeleteModal', params));
  },
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
  fetchAllTaxonomies: () => {
    dispatch(fetchTaxonomies());
  },
  loadMetadataGroups: () => {
    dispatch(fetchMetadataGroups());
  },
});

AdminTaxonomyEdit.propTypes = {
  intl: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  handleDeleteTaxonomy: PropTypes.func.isRequired,
  openTermEditModal: PropTypes.func.isRequired,
  openTermMoveModal: PropTypes.func.isRequired,
  openTermsImportModal: PropTypes.func.isRequired,
  openTaxonomyDeleteModal: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
  fetchAllTaxonomies: PropTypes.func.isRequired,
  loadMetadataGroups: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(null, mapDispatchToProps)(AdminTaxonomyEdit)));
